export interface ComponentIdentityRockBottomSpecification {
	id: number;
}

export class ComponentIdentityRockBottom {
	public readonly id: number;

	constructor(spec: ComponentIdentityRockBottomSpecification) {
		this.id = spec.id;
	}
}
